module.exports = __webpack_public_path__ + "static/media/left-1.d0688a30.jpg";